import { SsoSDK } from '@ome/sdk';
import { resolveEnvironmentVariables } from '@inn/utils';
import { xhr } from '@/utils';

const { variable: VITE_SSO_BASE } = resolveEnvironmentVariables('SSO_BASE');

const sdk = new SsoSDK({
  type: 'redirect',
  authAddress: VITE_SSO_BASE,
  xhr: xhr,
});

export function useSSOSdk() {
  return sdk;
}
